import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import styled from 'styled-components';
import translate from 'components/hoc/translate';

const Wrapper = styled.div`
    box-sizing: border-box;
    margin: 0 16px;
    width: 100%;
    color: #000;
    z-index: 1;

    @media screen and (min-width: 767px) {
        width: 12rem;
    }
`;

class CurrencySelectField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.selectedCurrency || null,
        };
    }

    handleChange = (event, key, payload) => {
        if (this.state.value === payload) {
            return;
        }

        this.setState({
            value: payload,
        });

        this.props.selectedValue(payload);
    }

    render() {
        const { translate } = this.props;
        const { supported: currencies } = this.context.config.currency;

        return (
            <Wrapper>
                <SelectField
                    floatingLabelText={ translate('pages.dashboard.select') }
                    fullWidth={ true }
                    value={ this.state.value }
                    onChange={ this.handleChange }
                >
                    {
                        currencies.map(function (item) {
                            return <MenuItem key={ item } value={ item } primaryText={ item } />;
                        })
                    }
                </SelectField>
            </Wrapper>
        );
    }
}

CurrencySelectField.contextTypes = {
    config: PropTypes.shape({
        currency: PropTypes.shape({
            supported: PropTypes.arrayOf(PropTypes.string),
        }),
    }),
};

CurrencySelectField.propTypes = {
    selectedCurrency: PropTypes.string.isRequired,
    selectedValue: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(CurrencySelectField);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/CurrencySelectField.js